import GarageDoorInstallationInformation from './GarageDoorInstallationInformation';

export default GarageDoorInstallationInformation;